'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("slick-carousel");
var Slick;
(function (Slick) {
    var MySlick = /** @class */ (function () {
        function MySlick() {
            this.createPosterSlick();
            this.createMovieSlick();
        }
        MySlick.prototype.createPosterSlick = function () {
            $('#bulletPosterSlick').slick({
                asNavFor: '#bulletPosterNaviSlick',
                dots: true,
                autoplay: false,
                slidesToShow: 1,
                variableWidth: false
            });
            $('#bulletPosterNaviSlick').slick({
                arrows: false,
                asNavFor: '#bulletPosterSlick',
                slidesToShow: 1
            });
        };
        MySlick.prototype.createMovieSlick = function () {
            $('#bulletMovieSlick').slick({
                asNavFor: '#bulletMovieNaviSlick',
                dots: true,
                autoplay: false,
                slidesToShow: 1,
                variableWidth: false
            });
            $('#bulletMovieNaviSlick').slick({
                arrows: false,
                asNavFor: '#bulletMovieSlick',
                slidesToShow: 1
            });
        };
        return MySlick;
    }());
    Slick.MySlick = MySlick;
})(Slick || (Slick = {}));
exports.default = Slick;
